import { IServiceCollectionRecord } from '@common/interfaces/i-service-collection-record';
import { IServiceCollectionScript } from '@common/interfaces/i-service-collection-script';

export class ServiceCollectionFactory {
    public static newServiceCollectionScript: () => IServiceCollectionScript;
    public static newApiServiceCollectionScript: () => IServiceCollectionScript;

    public static newServiceCollectionRecord: () => IServiceCollectionRecord;
    public static newApiServiceCollectionRecord: () => IServiceCollectionRecord;
}
